import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialInstagram = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="m3.463 18.174-.004-.01c-.205-.528-.356-1.152-.4-2.12C3.01 15.008 3 14.688 3 12.005s.012-3.003.058-4.037c.045-.969.196-1.593.401-2.123l.003-.007c.203-.54.522-1.028.933-1.432L4.4 4.4l.005-.006c.404-.411.893-.73 1.432-.932l.01-.004c.528-.205 1.151-.356 2.12-.4C9.003 3.01 9.324 3 12.006 3s3.002.012 4.037.058c.968.045 1.593.196 2.123.401l.007.003c.54.203 1.028.522 1.432.933l.006.005.005.006c.412.404.73.893.933 1.432l.003.01c.206.528.357 1.151.401 2.12m-17.895 0v.262m.405 9.944a4 4 0 0 0 .932 1.432l.006.005.006.006c.404.411.892.73 1.432.933l.008.003c.529.205 1.153.356 2.121.4m-4.505-2.78-.012-.063m-.393-2.067.016.084m-.016-.084v-.261m.393 2.328-.377-1.983m.377 1.983c-.16-.423-.325-1.012-.377-1.983m.377 1.983.017.044a3.95 3.95 0 0 0 .94 1.45c.408.416.903.737 1.45.94.438.17 1.056.35 2.11.398 1.064.048 1.393.058 4.038.058s2.974-.01 4.038-.058c1.055-.049 1.672-.228 2.11-.398a3.95 3.95 0 0 0 1.45-.94c.416-.408.737-.903.94-1.45.17-.438.35-1.056.398-2.11.048-1.064.058-1.393.058-4.038s-.01-2.974-.058-4.038c-.049-1.06-.23-1.679-.4-2.117a3.94 3.94 0 0 0-.94-1.443 3.9 3.9 0 0 0-1.441-.938c-.44-.171-1.058-.351-2.117-.4l-.262-.012M3.074 16.127l-.004-.083-.012-.262m4.91-12.724h.262m7.813 0h-.261m-7.552 0h7.552m-7.552 0c.876-.038 1.36-.046 3.776-.046s2.9.008 3.776.046m-7.552 0-.262.012c-1.055.049-1.673.228-2.11.398a3.95 3.95 0 0 0-1.454.945 4 4 0 0 0-.934 1.438c-.171.439-.351 1.058-.4 2.117l-.012.262m17.895 7.813c-.044.97-.195 1.593-.4 2.122l-.003.008a4 4 0 0 1-.933 1.432l-.006.006-.005.006a4 4 0 0 1-1.432.932l-.01.003c-.528.206-1.152.357-2.12.401M3.057 15.782c-.038-.876-.046-1.36-.046-3.776s.008-2.9.046-3.776m0 7.552V8.23m7.346 7.643a4.185 4.185 0 1 0 3.204-7.732 4.185 4.185 0 0 0-3.204 7.732ZM9.037 9.037a4.199 4.199 0 1 1 5.938 5.938 4.199 4.199 0 0 1-5.938-5.938Zm9.532-2.207a1.202 1.202 0 1 1-2.403 0 1.202 1.202 0 0 1 2.403 0Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialInstagram) as SvgIcon;
export { ForwardRef as ReactComponent };
